import React, { useEffect } from 'react';
import { Navigate } from 'react-router-dom';
import { useAuth } from '../context/AuthContext';

const PrivateRoute = ({ children, allowedRoles }) => {
  const { user, loading, logout } = useAuth();

  useEffect(() => {
    // If user tries to access unauthorized route, logout immediately
    if (user && allowedRoles && !allowedRoles.includes(user.role)) {
      logout();
    }
  }, [user, allowedRoles, logout]);

  if (loading) {
    return (
      <div className="loading">
        <div className="spinner"></div>
      </div>
    );
  }

  if (!user) {
    return <Navigate to="/login" replace />;
  }

  if (allowedRoles && !allowedRoles.includes(user.role)) {
    // Logout and redirect to login
    logout();
    return null;
  }

  return children;
};

export default PrivateRoute;
